module.exports = "/_next/static/images/earn-holding-63cdff9de6ce76d78c5087fb107a4495.png";